<template>
  <div class="top">
    <div class="big_title">集团荣誉</div>
    <div class="roll-box">
      <div class="text" :style="computedStyle">
        <div class="carousel">
          <div v-for="(item, index) in picList" :key="index">
            <img :src="item.url" style="height: 246px; margin: 0 30px" />
          </div>
          <div v-for="(item, index) in picList" :key="index + 'picList2'">
            <img :src="item.url" style="height: 246px; margin: 0 30px" />
          </div>
        </div>
      </div>
    </div>
    <!-- <vue3-seamless-scroll :list="picList" :direction="'left'" class="scroll">
      <div class="carousel">
        <div v-for="(item, index) in picList" :key="index">
          <img :src="item.url" style="height: 200px; margin: 0 30px" />
        </div>
      </div>
    </vue3-seamless-scroll> -->
    <div class="progressBox">
      <div v-for="(item, index) in list" :key="index" class="listBox">
        <div
          class="listItem"
          :class="[index % 2 === 0 ? 'leftItem' : 'rightItem']"
        >
          <div class="name">
            <div>{{ item.title }}</div>
          </div>
          <p class="date">
            {{ item.content || item.intro }}
          </p>
        </div>
      </div>
      <div class="centerLine"></div>
    </div>
  </div>
</template>
<script setup>
import api from "@/api/api";
import { ref, onMounted, computed } from "vue";
import { Vue3SeamlessScroll } from "vue3-seamless-scroll";
let list = ref([]);
let picList = ref([]);
let listData = ref([]);
const isImageAccessible = (url, callback) => {
  const img = new Image();

  img.onload = function () {
    // 图片加载成功，表示可访问
    callback(true, url);
  };

  img.onerror = function () {
    // 图片加载失败，可能是不可访问
    callback(false, url);
  };

  // 开始加载图片，触发请求
  img.src = url;
};
let getValue = async () => {
  let res = await api.getHonorList();
  if (res.code === "0") {
    list.value = res.res.data;
    picList.value = [];
    list.value
      .filter((item) => item.auditFlag === 1)
      .forEach((it) => {
        isImageAccessible(it.img, (isAccessible, imgUrl) => {
          if (isAccessible) {
            picList.value.push({
              url: imgUrl,
            });
          }
        });
      });
  }
};
let computedStyle = computed(() => {
  return { "animation-duration": picList.value.length * 4 + "s" };
});
onMounted(() => {
  getValue();
});
</script>
<style lang="less" scoped>
.roll-box {
  height: 246px;
  width: 100%;
  position: relative;
  overflow: hidden;
  margin-bottom: 74px;
}
.roll-box .text {
  position: absolute;
  white-space: nowrap;
  left: 0;
  top: 0;
  animation-name: roll;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
@keyframes roll {
  0% {
    transform: translate(0%, 0);
  }
  99.9999% {
    transform: translate(-50%, 0);
  }
  100% {
    /* 新增这部分，在动画结束时立即重置位置 */
    transform: translate(0%, 0);
  }
}
.carousel {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: left;
}
.top {
  width: 100%;
  .progressBox {
    position: relative;
    height: 100%;
    & > .listBox:nth-child(2n) {
      justify-content: flex-end;
      .listItem {
        transform: translate(35px, 0);
      }
    }
    & > .listBox:nth-child(2n + 1) {
      justify-content: flex-start;
      .listItem {
        transform: translate(-35px, 0);
      }
    }
    .listBox {
      width: 100%;
      position: relative;
      display: flex;
      align-items: stretch; /* 垂直拉伸以匹配子元素高度 */
      .listItem {
        width: 50%;
        padding: 9px 6px 9px 12px;
        border-radius: 6px;
        z-index: 2;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        justify-content: space-around;
        box-sizing: border-box;
        .name {
          width: 100%;
          div {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 44px;
            color: #009fe8;
            line-height: 67px;
            font-style: normal;
            transition: transform 0.2s;
          }
        }
        .date {
          width: 100%;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 16px;
          color: #333333;
          line-height: 40px;
          font-style: normal;
        }
      }
    }
    .centerLine {
      position: absolute;
      top: 44px;
      left: 50%;
      transform: translateX(-50%);
      height: calc(100% - 56px);
      width: 6px;
      background: #006ab1;
      opacity: 0.2;
    }
  }
}

.rightItem {
  position: relative;
  .name {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .date {
    text-align: left !important;
  }
}
.rightItem::before {
  content: "";
  width: 24px;
  height: 24px;
  border-radius: 50%;
  position: absolute;
  top: 28px;
  left: -51px;
  z-index: 3;
  background: #009fe8;
  transition: transform 0.2s;
  border: 4px solid #ffffff;
}
.rightItem:hover::before {
  transform: scale(1.3);
}
.rightItem:hover {
  .name {
    div {
      transform: scale(1.2);
    }
  }
}
.leftItem {
  position: relative;
  .name {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .date {
    text-align: right !important;
  }
}
.leftItem::before {
  content: "";
  width: 24px;
  height: 24px;
  border-radius: 50%;
  position: absolute;
  top: 28px;
  right: -51px;
  z-index: 3;
  background: #009fe8;
  transition: transform 0.2s;
  border: 4px solid #ffffff;
}
.leftItem:hover::before {
  transform: scale(1.3);
}
.leftItem:hover {
  .name {
    div {
      transform: scale(1.2);
    }
  }
}
.big_title {
  height: 5.27vh;
  font-weight: 600;
  font-size: 48px;
  line-height: 5.27vh;
  text-align: left;
  font-style: normal;
  color: #333333;
  margin-bottom: 3.38vh;
  font-family: PingFangSC, PingFang SC;
}
</style>
